<template>
    <div class="row mt-2 mb-3">
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="trans_date">Trans Date</label>
            <b-form-group id="trans_date" label-for="trans_date">
                <b-form-input class="mt-2 field-container fields" type="date" v-model="form.trans_date"></b-form-input>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="principal">Principal</label>
            <b-form-group id="principal" label-for="principal">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.principal"></b-form-input>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="interest">Interest</label>
            <b-form-group id="interest" label-for="interest">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.interest"></b-form-input>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="principal_balance">Principal Balance</label>
            <b-form-group id="principal_balance" label-for="principal_balance">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.principal_balance"></b-form-input>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="interest_balance">Interest Balance</label>
            <b-form-group id="interest_balance" label-for="interest_balance">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.interest_balance"></b-form-input>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="principal_paid">Principal Paid</label>
            <b-form-group id="principal_paid" label-for="principal_paid">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.principal_paid"></b-form-input>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="interest_paid">Interest Paid</label>
            <b-form-group id="interest_paid" label-for="interest_paid">
                <b-form-input class="mt-2 field-container fields" type="number" step="any"
                    v-model="form.interest_paid"></b-form-input>
            </b-form-group>
        </div>
    </div>
</template>

<script>
export default {
    props: ['form'],

}
</script>